import ratImage from "../assets/rat_image.png";

const r4t = {
  title: "R4T STL Files",
  description:
    "Rapid Attack Tool(R4T) is an IoT device powered by an ESP32-C3, designed for Wi-Fi and Bluetooth reconnaissance and attack simulations for penetration testing and educational use.",
  components:
    "Seedstudio esp32 C3, 250mah lipo battery, SSD1306 display, 5 buttons",
  links: [
    {
      label: ".STL",
      url: "https://drive.google.com/file/d/1WwKaByXuEgcy7v96t58L9r6DU9ifuGiU/view?usp=sharing",
    },
    {
      label: ".FCStd",
      url: "https://drive.google.com/file/d/1XRfA2Wc3kPfuRtgYCsTg8JFJvh1dRMig/view?usp=sharing",
    },
  ],
  image: ratImage,
};

export const assets = [r4t];
